import { createSlice } from '../../../common/redux.Interface.Reducer'
import { GlobalFeatureNameSpaceNotary } from '../../../common/globalNotary'
import { destroySession } from '../../../common/sessionGate'

/// the following imports have nothing to do with redux, just something to be called from the reducers
import { onLogout } from './Logout'

const initialState = { loggedin: false, authToken: null }

const signinsignoutSlice = createSlice({
  name: GlobalFeatureNameSpaceNotary.SIGNIN_SIGNOUT,
  initialState,
  reducers: {
    signinGoogle (state) {
      state.loggedin = true
      return state
    },
    signinMicrosoft (state) {
      state.loggedin = true
      return state
    },
    signOut (state) {
      destroySession()
      onLogout()
      state.loggedin = true
      return state
    }
  }
})

export const { signinGoogle, signinMicrosoft, signOut } =
  signinsignoutSlice.actions

export default signinsignoutSlice.reducer
